import { Button, Form, Input, message, Modal} from 'antd';
import React, { useState } from 'react'
import { useAddNewsMutation } from '../../store/ReactWebSiteApi';
import MyEditor from '../../cpn/MyEditor';
import NewsTypeForm from '../newsType/NewsTypeForm';
import UploadOne from '../../cpn/UploadOne';
import GetUser from '../../cpn/GetUser';

function NewsAdd() {
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [info,setInfo] = useState({
        en_e_id:localStorage.getItem('e_id'),
        en_dept_id:localStorage.getItem('ed_id'),
        en_uid:localStorage.getItem('eu_id'),
        en_uname:localStorage.getItem('eu_name'),
    });
    const [addNews] = useAddNewsMutation()
    // console.log(newsType);
    return (
        <>
            <Button type='primary' onClick={() => {setOpen(true)}}>新增</Button>
            <Modal
                open={open}
                title='新增新闻'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    addNews(info).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('新增成功！')
                            setOpen(false)
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败！'+res.data.Message)
                        }
                    })
                }}
                width={1000}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}                   
                >
                    <NewsTypeForm
                        required
                        onChange={(e,f) => {setInfo(prevState=>({...prevState,en_type_id:e,en_type_name:f}))}}
                    />
                    <Form.Item name="name" label='新闻标题' wrapperCol={{span:15}} required>
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,en_name:e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item name="content" label='新闻正文' wrapperCol={{span:15}} required>
                        <MyEditor onChange={(e) => {setInfo(prevState=>({...prevState,en_content:e}))}} value={info.en_content}/>
                    </Form.Item>
                    <UploadOne
                        fileStr={(e) => {setInfo(prevsState=>({...prevsState,en_image:e,}))}}
                        label='首图'
                        wrapperCol={{span:20}}
                        required
                    />
                    <GetUser
                        label='编辑'
                        wrapperCol={{span:5}}
                        required
                        getUser={(e) => {setInfo(prevsState=>({...prevsState,en_bianji:e.ed_name + ' - ' +e.label}))}}
                    />
                    <GetUser
                        label='初审'
                        wrapperCol={{span:5}}
                        required
                        getUser={(e) => {setInfo(prevsState=>({...prevsState,en_chushen:e.ed_name + ' - ' +e.label}))}}
                    />
                    <GetUser
                        label='终审'
                        wrapperCol={{span:5}}
                        required
                        getUser={(e) => {setInfo(prevsState=>({...prevsState,en_zhongshen:e.ed_name + ' - ' +e.label}))}}
                    />
                    
                </Form>
            </Modal>
        </>
    )
}

export default NewsAdd